<template>
  <div class="survey-container">
    <div class="survey-left" :style="{ width: leftWidth }">
      <slot name="left"></slot>
    </div>
    <div class="survey-main bg-bg-common-color" :style="mainStyle">
      <slot name="default"></slot>
    </div>
    <div class="survey-right" :style="rightStyle">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyContainer',
  props: {
    leftWidth: {
      type: String,
      default: '300px'
    },
    rightWidth: {
      type: String,
      default: '300px'
    }
  },
  computed: {
    mainStyle() {
      return {
        paddingLeft: this.leftWidth,
        paddingRight: this.rightWidth
      }
    },
    rightStyle() {
      const width = parseFloat(this.rightWidth)

      return {
        width: width - 2 + 'px'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.survey {
  &-container {
    height: 100%;
    position: relative;

    & > div {
      height: 100%;
    }
  }

  &-left {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
  }

  &-main {
    overflow-y: scroll;
  }

  &-right {
    position: absolute;
    top: 0;
    right: 10px;
    z-index: 100;
  }
}
</style>
